import { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import { StationsState } from '../../types';

import { getSelectedStationPrices } from '../operations/getSelectedStationPrices';

import { STATUS_LOADING } from 'common/constants';

export const setSelectedStationPrices = (builder: ActionReducerMapBuilder<StationsState>) => builder
  .addCase(getSelectedStationPrices.pending, (state) => {
    state.selectedStation.pricesLoadingStatus = STATUS_LOADING.load;
  })
  .addCase(getSelectedStationPrices.fulfilled, (state, { payload }) => {
    state.selectedStation.pricesLoadingStatus = STATUS_LOADING.done;
    state.selectedStation.prices = payload;
  })
  .addCase(getSelectedStationPrices.rejected, (state, { meta }) => {
    if (meta.aborted) {
      state.selectedStation.pricesLoadingStatus = STATUS_LOADING.abort;
    } else {
      state.selectedStation.pricesLoadingStatus = STATUS_LOADING.error;
    }
    state.selectedStation.prices = undefined;
  });
